import { useDispatch, useSelector } from 'react-redux';
import { removeAlternativeBidOffer, updateAlternativeBidOffer } from '../../../../../../actions';
import { FormBid } from './EditBidsForm';
import api, { auctionVehiclesAdapter } from 'services/api/admin-auction-vehicles';
import { useParams } from 'react-router-dom';

const defaultHandler = (_bid: FormBid) => {};

export const useLocalUpdates = (type: string, vehicleId: number) => {
  const dispatch = useDispatch<any>();
  const { id: auctionId } = useParams<{ id: string }>();

  const { page, perPage, filters } = useSelector((state: any) => state.auctionVehicles);

  const alternativeOfferSaveLocalUpdate = (bid: FormBid) => {
    dispatch(updateAlternativeBidOffer({ id: bid.id, amount: bid.bid }));
    if (!!auctionId && window.location.pathname.startsWith('/admin/auctions')) {
      dispatch(
        api.util.updateQueryData(
          'getAuctionVehicles',
          {
            limit: perPage,
            offset: page,
            auction_id: auctionId,
            ...filters
          },
          draft => {
            const currentOffers = draft.rows.entities[vehicleId]?.alternative_bid_offers || [];

            const newOffers = currentOffers.map((offer: any) => {
              if (offer.id !== bid.id) return offer;
              return { ...offer, amount: bid.bid };
            });
            auctionVehiclesAdapter.updateOne(draft.rows, {
              id: vehicleId,
              changes: { alternative_bid_offers: newOffers, top_alternative_bid_offer: newOffers[0] }
            });
          }
        )
      );
    }
  };

  const alternativeOfferRemoveLocal = (bid: FormBid) => {
    dispatch(removeAlternativeBidOffer({ id: bid.id }));
    if (!!auctionId && window.location.pathname.startsWith('/admin/auctions')) {
      dispatch(
        api.util.updateQueryData(
          'getAuctionVehicles',
          {
            limit: perPage,
            offset: page,
            auction_id: auctionId,
            ...filters
          },
          draft => {
            const currentOffers = draft.rows.entities[vehicleId]?.alternative_bid_offers || [];

            const newOffers = currentOffers.filter((offer: any) => offer.id !== bid.id);
            auctionVehiclesAdapter.updateOne(draft.rows, {
              id: vehicleId,
              changes: { alternative_bid_offers: newOffers, top_alternative_bid_offer: newOffers[0] }
            });
          }
        )
      );
    }
  };

  const localUpdateMap = {
    bids: {
      localSaveBid: defaultHandler,
      localRemoveBid: defaultHandler
    },
    offers: {
      localSaveBid: defaultHandler,
      localRemoveBid: defaultHandler
    },
    alternativeOffers: {
      localSaveBid: alternativeOfferSaveLocalUpdate,
      localRemoveBid: alternativeOfferRemoveLocal
    }
  };

  return localUpdateMap[type as keyof typeof localUpdateMap];
};
